'use client';

import { WarningIcon } from '@/components/icons/warning-icon';
import clsx from 'clsx';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';
import soonerStyles from './sonner.module.scss';

type ToasterComponentProps = {
  headerHeight: number;
} & ToasterProps;

const Toaster = ({ headerHeight, ...props }: ToasterComponentProps): React.JSX.Element => {
  const { theme = 'system' } = useTheme();
  props.position = 'top-center';

  return (
    <Sonner closeButton
      expand
      className={clsx('toaster group', soonerStyles['sonner-container'], soonerStyles.custom)}
      icons={{
        error: <WarningIcon className="icon icon-primary"
          role="img"
        />,
      }}
      mobileOffset={{ left: '0', right: '0' }}
      offset={{ left: '0', right: '0' }}
      style={
        {
          /* eslint-disable @typescript-eslint/naming-convention */
          '--normal-bg': 'var(--popover)',
          '--normal-border': 'var(--border)',
          '--normal-text': 'var(--popover-foreground)',
          /* eslint-enable @typescript-eslint/naming-convention */
        } as React.CSSProperties
      }
      theme={theme as ToasterProps['theme']}
      toastOptions={{
        classNames: {
          icon: soonerStyles['sonner-icon'],
          title: soonerStyles['sonner-title'],
        },
        style: {
          fontFamily: 'var(--font-work-sans)',
          fontSize: '20px',
          fontWeight: '700',
          gap: '20px',
          justifyContent: 'center',
          lineHeight: '26px',
          top: `${headerHeight + 20}px`,
          width: '100%',
        },
        ...props.toastOptions,
      }}
      {...props}
    />
  );
};

export { Toaster };
